import { createAuthClient } from "better-auth/client";
import { emailOTPClient } from "better-auth/client/plugins";
import { resolveRuntimeAuthBaseUrl } from "../app/core/api-url";

export const authClient = createAuthClient({
  baseURL: resolveRuntimeAuthBaseUrl(),
  fetchOptions: {
    credentials: "include",
  },
  plugins: [emailOTPClient()],
});
